import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8fd1f378")

_pushScopeId("data-v-8fd1f378")
const _hoisted_1 = { class: "white-back-mask" }
const _hoisted_2 = { class: "wechat-login-module" }
const _hoisted_3 = { class: "wechat-login-content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "title" }, "验证微信", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "desc" }, "请使用微信扫码", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccountManageHeader = _resolveComponent("AccountManageHeader")!
  const _component_AccountQrcodeVerification = _resolveComponent("AccountQrcodeVerification")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_AccountManageHeader, { onClose: _ctx.closeModal }, null, 8, ["onClose"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_AccountQrcodeVerification, {
            size: 110,
            onSuccess: _ctx.handleVerificationSuccess,
            onError: _ctx.handleVerificationError
          }, null, 8, ["onSuccess", "onError"]),
          _hoisted_6
        ])
      ])
    ])
  ]))
})